/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreatePaymentTemplateRequest} from '@cash-web/protos/squareup/cash/paymenttemplate/v1/payment_template.pb'
import {CreatePaymentTemplateResponse} from '@cash-web/protos/squareup/cash/paymenttemplate/v1/payment_template.pb'


export const createPaymentTemplate = (request: CreatePaymentTemplateRequest, options?: CashRequestOptions) => post<CreatePaymentTemplateRequest, CreatePaymentTemplateResponse>("/2.0/cash/create-payment-template", request, {...options, rejectOnError: true })